/** Freelancer profile cards only: quieter labels, dark values (admin screens keep the InfoDetails defaults). */
export const profileLabelColor = '#6B6B6B';
export const profileValueColor = '#141414';
